import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change } from 'redux-form';
import ChangeDeliveryDialog from './AddWidgetDialog';
import { IApplicationState } from 'ducks/reducers';
import { selectors as dashboardMaintenanceSelectors } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import { selectors as staffSelectors } from 'ducks/staff';

const params = new URLSearchParams(location.search);

const mapStateToProps = (state: IApplicationState) => ({
  selectedDashboardId: dashboardMaintenanceSelectors.selected(state)?.DashboardId ?? params.get('DashboardId'),
  selectedDashboardType: dashboardMaintenanceSelectors.selected(state)?.DashboardType,
  dirty: isDirty('AddWidgetForm')(state),
  values: getFormValues('AddWidgetForm')(state),
  isValid: isValid('AddWidgetForm')(state),
  currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : ''
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('AddWidgetForm'),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change('AddWidgetForm', fieldName, fieldValue),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChangeDeliveryDialog);
